import { STATES_LIST } from "Constants/constant";

export const isValidShiftCoordinate = (lat, lng) => {
  if (lat == null || lng == null) return false;
  const numLat = Number(lat);
  const numLng = Number(lng);
  return (
    !Number.isNaN(numLat) &&
    !Number.isNaN(numLng) &&
    numLat >= -90 &&
    numLat <= 90 &&
    numLng >= -180 &&
    numLng <= 180 &&
    !(numLat === 0 && numLng === 0)
  );
};

export const extractShiftLocationFromResponse = (response) => {
  const payload = response?.data ?? response;
  if (payload?.street || payload?.suburb || payload?.postcode) {
    return payload;
  }
  if (payload?.data && typeof payload.data === "object") {
    return payload.data;
  }
  return null;
};

export const EMPTY_SHIFT_LOCATION = {
  street: "",
  suburb: "",
  state: null,
  state_name: "",
  postcode: "",
  lat: null,
  lng: null,
};

export const hasDisplayableShiftLocation = (locationData) =>
  !!(locationData?.street || locationData?.suburb || locationData?.postcode);

export const mapShiftLocationApiResponse = (data) => {
  if (!data) return null;

  const stateName = data.state_name || "";
  let stateValue = data.state ?? null;

  if (stateName && typeof stateName === "string") {
    const stateOption = STATES_LIST.find(
      (s) =>
        s.value?.toLowerCase() === stateName.toLowerCase() ||
        s.label?.toLowerCase() === stateName.toLowerCase()
    );
    if (stateOption && (stateValue == null || typeof stateValue === "number")) {
      stateValue = stateOption.value;
    }
  }

  const lat =
    data.lat != null && data.lat !== "" ? Number(data.lat) : null;
  const lng =
    data.lng != null && data.lng !== "" ? Number(data.lng) : null;

  const hasValidCoordinates = isValidShiftCoordinate(lat, lng);

  return {
    street: data.street || "",
    suburb: data.suburb || "",
    state: stateValue,
    state_name: stateName || (typeof stateValue === "string" ? stateValue : ""),
    postcode: data.postcode || "",
    lat: hasValidCoordinates ? lat : null,
    lng: hasValidCoordinates ? lng : null,
  };
};

const getParticipantLocationUuids = (watchFormData) =>
  (watchFormData?.advance_selected_participants || [])
    .map((p) => p?.uuid || p?.value || p)
    .filter(Boolean);

/**
 * Build the advance-mode location request.
 * Home Management ON  → prefer SIL home address; if that home has no
 *                       displayable address, callers should fall back to
 *                       `fallback` (first selected participant with an address).
 * Home Management OFF → participant list only.
 */
export const getAdvanceShiftLocationRequest = (watchFormData) => {
  const participantUuids = getParticipantLocationUuids(watchFormData);
  const participantRequest = participantUuids.length
    ? { source: "participant", uuids: participantUuids }
    : null;

  if (watchFormData?.advance_sil_home_enabled) {
    const homeUuid = watchFormData?.advance_sil_home_uuid;
    if (!homeUuid) {
      // Toggle on but no home picked yet — still allow participant fallback.
      return participantRequest;
    }
    return {
      source: "home",
      uuids: [homeUuid],
      fallback: participantRequest,
    };
  }

  return participantRequest;
};

/** Stable key so home + participant fallback re-runs when either source changes. */
export const getAdvanceShiftLocationRequestKey = (request) => {
  if (!request?.uuids?.length) return null;
  const primary = `${request.source}:${request.uuids.join(",")}`;
  if (!request.fallback?.uuids?.length) return primary;
  return `${primary}|fb:${request.fallback.source}:${request.fallback.uuids.join(",")}`;
};
